import { BlogPost } from '../types/blog-admin';

interface SitemapUrl {
  loc: string;
  lastmod?: string;
  changefreq?: 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';
  priority?: number;
}

export function generateSitemap(posts: BlogPost[], baseUrl: string): string {
  const urls: SitemapUrl[] = [
    // Static pages
    {
      loc: `${baseUrl}/`,
      changefreq: 'weekly',
      priority: 1.0,
    },
    {
      loc: `${baseUrl}/blog`,
      changefreq: 'daily',
      priority: 0.9,
    },
    {
      loc: `${baseUrl}/login`,
      changefreq: 'monthly',
      priority: 0.5,
    },
    {
      loc: `${baseUrl}/terms`,
      changefreq: 'monthly',
      priority: 0.3,
    },
    {
      loc: `${baseUrl}/privacy`,
      changefreq: 'monthly',
      priority: 0.3,
    },
  ];

  // Add blog posts
  posts.forEach((post) => {
    if (post.status === 'published' && post.publishedAt) {
      urls.push({
        loc: `${baseUrl}/blog/${post.slug}`,
        lastmod: new Date(post.updatedAt.toMillis()).toISOString().split('T')[0],
        changefreq: 'weekly',
        priority: 0.8,
      });
    }
  });

  // Generate XML
  const urlEntries = urls
    .map(
      (url) => `
  <url>
    <loc>${escapeXml(url.loc)}</loc>
    ${url.lastmod ? `<lastmod>${url.lastmod}</lastmod>` : ''}
    ${url.changefreq ? `<changefreq>${url.changefreq}</changefreq>` : ''}
    ${url.priority !== undefined ? `<priority>${url.priority.toFixed(1)}</priority>` : ''}
  </url>`
    )
    .join('');

  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urlEntries}
</urlset>`;
}

function escapeXml(unsafe: string): string {
  return unsafe.replace(/[<>&'"]/g, (c) => {
    switch (c) {
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '&':
        return '&amp;';
      case "'":
        return '&apos;';
      case '"':
        return '&quot;';
      default:
        return c;
    }
  });
}
